import { library, help, rocket, image, playCircle, map, volumeMedium, informationCircle } from 'ionicons/icons';

type BibleContentType = {
    intro: 'intro',
    lesson: 'lesson',
    questions: 'questions',
    challenges: 'challenges',
    kmlMap: 'kmlMap',
    videos: 'videos',
    images: 'images',
    audio: 'audio',
    verse: 'verse',
}
export const BibleContent: BibleContentType = {
    intro: 'intro',
    lesson: 'lesson',
    questions: 'questions',
    challenges: 'challenges',
    kmlMap: 'kmlMap',
    videos: 'videos',
    images: 'images',
    audio: 'audio',
    verse: 'verse',
}

export const BibleContentLocation = {
    inline: 'inline',
    footer: 'footer',
    modal: 'modal'
}

export type BibleContentLocationValues = typeof BibleContentLocation[keyof typeof BibleContentLocation]

export type BibleContentValues = typeof BibleContent[keyof typeof BibleContent];

export const AllBibleContent: BibleContentValues[] = Array.from(Object.values(BibleContent));

interface IBibleContentData {
    title: string,
    name: string,
    icon: string,
    location: BibleContentLocationValues
}

export const BibleContentData:{ [key in BibleContentValues]: IBibleContentData } = {
    [BibleContent.intro]: {
        title: 'Bible Study Introduction',
        name: '',
        icon: '',
        location: BibleContentLocation.inline
    },
    [BibleContent.lesson]: {
        title: 'Bible Study Lesson',
        name: 'Lesson',
        icon: library,
        location: BibleContentLocation.footer
    },
    [BibleContent.kmlMap]: {
        title: 'Bible Study Map',
        name: 'Maps',
        icon: map,
        location: BibleContentLocation.modal
    },
    [BibleContent.questions]: {
        title: 'Bible Study Questions',
        name: 'Questions',
        icon: help,
        location: BibleContentLocation.footer
    },
    [BibleContent.challenges]: {
        title: 'Bible Study Challenges',
        name: 'Challenges',
        icon: rocket,
        location: BibleContentLocation.footer
    },
    [BibleContent.videos]: {
        title: 'Bible Study Videos',
        name: 'Videos',
        icon: playCircle,
        location: BibleContentLocation.modal
    },
    [BibleContent.images]: { 
        title: 'Bible Study Images',
        name: 'Images',
        icon: image,
        location: BibleContentLocation.footer
    },
    [BibleContent.audio]: {
        title: 'Bible Study Audio',
        name: 'Audio',
        icon: volumeMedium,
        location: BibleContentLocation.footer
    },
    [BibleContent.verse]: {
        title: 'Bible Verse Details',
        name: 'Verse',
        icon: informationCircle,
        location: BibleContentLocation.footer
    }
}

export default BibleContent;